import { saveFailure } from './EditorSaveBar';
import type { Issue } from './editorModel';
import type { MobileSaveState } from './MobileEditorFooter';
import type { useCommunicationCatalog } from './useCommunicationCatalog';
import type { useMessagesView } from './useMessagesView';

/**
 * Speichern, Verwerfen und der Grund, wenn es nicht klappt — für die Leiste und das Vollbild auf dem
 * Telefon aus einer Hand, damit beide dieselben Sperren und Rückmeldungen haben.
 */
export function messagesSave(
  catalog: ReturnType<typeof useCommunicationCatalog>,
  view: ReturnType<typeof useMessagesView>,
  issues: Issue[],
  phone: boolean,
  editable: boolean,
) {
  const failure = saveFailure(view.attempted, issues, catalog.saveProblem, (issue) => {
    view.jumpTo(issue);
    if (phone) view.setPhoneEditorOpen(true);
  });
  const save = () => {
    view.setAttempted(true);
    if (issues.length === 0) catalog.submit({ onSuccess: () => view.setAttempted(false) });
  };
  const discard = () => {
    view.setAttempted(false);
    catalog.discard();
  };
  const sheet: MobileSaveState = {
    editable,
    dirty: catalog.dirty,
    saving: catalog.save.isPending,
    blocked: !!catalog.switches.pending,
    conflict: catalog.conflict,
    reloadFailed: catalog.reloadFailed,
    failure,
    onDiscard: discard,
    onSave: save,
    onReload: () => void catalog.reload(),
    onClose: () => view.setPhoneEditorOpen(false),
  };
  return { failure, save, discard, sheet };
}
